import React from "react";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";
import { Square6Style } from "./css/Square6Style";
const Template = (props) => {
  return (
    <Square6Style>
     <div className="container_two_six">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="back-layer">
          <TemplateImage slideType={props.slideType} file={props.file} />
        </div>
        <div className="front-layer">
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
        </div>
        <div className="text-wrappers">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Square6Style>
  );
};

export default Template;
